<template>
  <div class="jinriShow">
    <!-- <div class="mainTitle">{{content.title}}</div> -->
    <div class="subtitle">{{ content.title }}</div>

    <div class="detailInfor">
      <!-- <iframe :src="getLink(item.standardData)" frameborder="0" width="96%" height="500px"></iframe> -->
      <span v-html="content.content && processLinks(content.content).replace(/\n/g, '</br>')"></span>
    </div>
    <div class="detailInfor" v-for="(item, ind) in content.imgs" :key="'a' + ind">
      <div style="text-align: center; text-indent: 0">
        <img :src="item" alt="" />
      </div>
    </div>
    <div class="detailInfor" v-for="(item, inds) in content.videos" :key="'b' + inds">
      <div style="text-align: center; text-indent: 0">
        <Video :src="item" width="100%" height="360px"></Video>
      </div>
    </div>

    <pinglun v-if="contentId.length" :contentId="contentId" :dataType="1"></pinglun>
  </div>
</template>
<script>
import Video from '../videos.vue'
import pinglun from '../../components/flowDetail/pinglun.vue'
export default {
  name: 'forward',
  components: {
    Video,
    pinglun
  },
  props: {
    // content:{
    //     type:Array
    // },
    // demonstrations:{
    //   type:String,
    //   default:'cmwz'
    // },
    // title:Boolean
  },
  data() {
    return {
      content: [],
      contentId: []
    }
  },
  created() {
    this.getTitle()
  },
  methods: {
    getTitle() {
      this.$http
        .get('/zciid-deliverable/api/grab/start/data.json', {
          id: this.getQuery('forwardId')
        })
        .then((res) => {
          if (res.state == 1) {
            var contentId = this.$contentId
            this.content = res.data
            this.contentId = [
              [
                { contentId: contentId, standardEnName: 'appName', standardData: res.data.title },
                { contentId: contentId, standardEnName: 'productBrief', standardData: res.data.content }
              ]
            ]
            // this.$emit('changeOdzidName',res.data.title);
          }
        })
    },
    //处理文本中的链接
    processLinks(txtContent) {
      var httpReg = new RegExp('(http[s]{0,1}|ftp)://[a-zA-Z0-9\\.\\-]+\\.([a-zA-Z]{2,4})(:\\d+)?(/[a-zA-Z0-9\\.\\-~!@#$%^&amp;*+?:_/=<>]*)?', 'gi') //用于判断文本内容超链接
      //文本地址变为a链接
      return txtContent.replace(httpReg, function (httpText) {
        return '<a style="color:#0c78cf;" href="' + httpText + '"target="_blank">' + httpText + '</a>'
      })
    },
    isPic(url) {
      if ((url && typeof url == 'string' && url.indexOf('.png') > 0) || (url && typeof url == 'string' && url.indexOf('.jpg') > 0)) {
        return true
      }
      return false
    }
  }
}
</script>
<style scoped>
.title {
  padding-left: 30px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
  background: url('../../assets/image/images/abduction_zsb.png') no-repeat left center / 20px 20px;
}
.jinriShow {
  padding: 20px 10px 0;
  /* height: calc( 100% - 36px ); */
  width: 1200px;
  margin: 0 auto;
  /* border: 1px solid #ededed; */
  box-sizing: border-box;
  /* overflow: auto; */
}
.mainTitle {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  font-size: 18px;
  font-weight: 800;
  color: #333;
  margin-bottom: 28px;
  text-align: center;
}
.subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 14px;
}
.statement {
  background-color: #f7f7f7;
  padding: 13px 20px;
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}
.information {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}
.information div {
  margin-right: 20px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.information span {
  font-size: 12px;
  color: #666;
}
.detailInfor {
  margin-bottom: 12px;
  line-height: 26px;
  font-size: 14px;
  /* text-indent: 24px; */
}
.detailInfor:last-child {
  margin-bottom: 0;
}
.detailInfor img,
.detailInfor video {
  width: 100%;
  height: 360px;
  object-fit: contain;
}
@media screen and (min-width: 111px) and (max-width: 768px) {
  .jinriShow {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/floorBlock/forward.vue